<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">

        </navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="#pablo">{{this.$route.name}}</a>
    </div>

    <template slot="navbar-menu">
      <!--
      <form>
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="nc-icon nc-zoom-split"></i>
            </div>
          </div>
        </div>
      </form>
      -->
      <ul class="navbar-nav">
        
        <li v-if="PinnedUserAndNotLocalHost && this.hasValhallaScale" class="nav-item" :key="componentKey">
          <a v-on:click="openInitialReport" class="nav-link btn-rotate" title="View Initial Report">
            <i class="nc-icon nc-paper"></i>
          </a>
        </li>

        <li v-if="PinnedUserAndNotLocalHost && this.hasValhallaScale" class="nav-item" :key="componentKeyTwo">
          <a v-on:click="openFollowUpReport" class="nav-link btn-rotate" title="View Follow-Up Report">
            <i class="nc-icon nc-single-copy-04"></i>
          </a>
        </li>
        
        <li v-if="PinnedUserAndNotLocalHost" class="nav-item">
          <a v-on:click="openUserMessageModal" class="nav-link btn-rotate" title="Send a Message">
            <i class="nc-icon nc-email-85"></i>
          </a>
        </li>
        <li v-if="PinnedUserAndNotLocalHost" class="nav-item">
          <a v-on:click="openUserDocumentModal" class="nav-link btn-rotate" title="Send a document">
            <i class="fa fa-file-o" aria-hidden="true"></i>
          </a>
        </li>

        <drop-down icon="nc-icon nc-share-66" tag="li"
          position="right"
          direction="none"
          class="nav-item btn-rotate dropdown"
          v-if="PinnedUserAndNotLocalHost && this.practiceHasSurveys" 
          :key="componentKeyFour">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="nc-icon nc-share-66" title="Send a Survey"></i>
          </a>
          <h6 class="dropdown-header text-center">Send a Survey</h6>
          <div v-for="survey in surveys" v-bind:key="survey.id">
            <div class="dropdown-item" @click="sendSurvey(survey)">
              {{survey.title}}
            </div>
          </div>
        </drop-down>
        <!-- <router-link to="/ProgressTracker" class="nav-item coust-mt-2 mr-3" v-if="showAIChatBotIcon">
          <i class="nc-icon nc-chat-33" 
            data-bs-toggle="tooltip" 
            data-bs-placement="right" 
            title="Progress Tracker" 
            style="font-size: 20px; cursor: pointer;"></i>
        </router-link> -->
        <!-- Demo practice only, and only on the practice dashboard. Slides the
             demo data forward so its 120-day history ends today. -->
        <li v-if="showRefreshDemoData" class="nav-item">
          <button type="button"
                  class="refresh-demo-data-btn"
                  :class="{ 'is-refreshing': isRefreshingDemoData }"
                  :disabled="isRefreshingDemoData"
                  @click="refreshDemoData">
            <i :class="isRefreshingDemoData ? 'el-icon-loading' : 'el-icon-refresh'"></i>
            Refresh Demo Data
          </button>
        </li>

        <drop-down icon="nc-icon nc-layout-11" tag="li"
                   position="right"
                   direction="none"
                   class="nav-item btn-rotate dropdown"
                   v-if="this.isOnDraggableDashboard"
                   :closeOnClick="false">
          <a slot="title"
             slot-scope="{isOpen}"
             class="nav-link dropdown-toggle"
             data-toggle="dropdown"
             aria-haspopup="true"
             :aria-expanded="isOpen">
            <i class="nc-icon nc-layout-11" title="Hide/Show Tiles"></i>
          </a>
          <h6 class="dropdown-header text-center">Hide/Show Tiles</h6>
          <div v-for="tile in draggableTiles" v-bind:key="tile.name">
            <div class="dropdown-item">
              <input class="tileControlCheckBox" type='checkbox' @change="saveTileHiddenState(tile)" :checked="!tile.hidden"/>
              {{tile.name}}
            </div>
          </div>
          <p-button @click="resetTilesToInitialLayout" class='resetTileButton'>Reset</p-button>
        </drop-down>

        <drop-down icon="nc-icon nc-settings-gear-65" position="right" direction="none" class="nav-item btn-rotate dropdown">
          
          <h6 class="dropdown-header">Settings</h6>
          <a class="dropdown-item" @click="goToMyAccount">My Account</a>
          <a class="dropdown-item" @click="callLogout">Logout</a>
        </drop-down>
      </ul>

      <el-dialog
        :visible.sync="modalControls.messageModal"
        :center='true'
        :append-to-body="true"
        width="75%">
        <MessageForm :key="componentKeyThree" @sendMessage="sendMessage" :sendUserSurvey="this.getUserSurvey()" :messageSubject="this.getMessageSubject()" :messageContent="this.messageContent" :to='[selectedUsersLogin]'></MessageForm>
      </el-dialog>
      <el-dialog
        :visible.sync="modalControls.documentModal"
        :center='true'
        :append-to-body="true"
         width="45%">
         <AssignDocument></AssignDocument>
      </el-dialog>

      <el-dialog
        title="Refresh Demo Data"
        :visible.sync="modalControls.refreshDemoDataModal"
        :center='true'
        :append-to-body="true"
        width="30%">
        <div class="refresh-demo-data-result">
          <i class="refresh-demo-data-result-icon"
             :class="refreshDemoDataSucceeded ? 'el-icon-circle-check text-success' : 'el-icon-circle-close text-danger'"></i>
          <p>{{ refreshDemoDataMessage }}</p>
        </div>
        <span slot="footer">
          <p-button type="primary" @click="modalControls.refreshDemoDataModal = false">OK</p-button>
        </span>
      </el-dialog>

    </template>
  </navbar>
</template>
<script>
  import { Navbar, NavbarToggleButton, Modal } from 'src/components/UIComponents';
  import PracticeServices from "src/services/practices/practiceServices.js"	
  import MessagingServices from "src/services/Messaging/MessagingServices.js"
  import RefreshDemoDataServices from "src/services/RefreshDemoData/refreshDemoDataServices.js"
  import MessageForm from "@/components/UIComponents/MessageForm.vue"
  import AssignDocument from "@/components/Dashboard/Views/Resource/AssignDocument.vue"
  import {redirectToOldPracticeDashboard} from "@/util/OldDashboardLink.js";
  import {logout} from "@/util/LogoutProcess"
  

  export default {
    components: {
      Navbar,
      NavbarToggleButton,
      Modal,
      MessageForm,
      AssignDocument,
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false,
        modalControls: {
          messageModal: false,
          documentModal:false,
          refreshDemoDataModal: false
        },
        isRefreshingDemoData: false,
        refreshDemoDataMessage: "",
        refreshDemoDataSucceeded: false,
        componentsList: "",
        hasValhallaScale: "",
        componentKey: 0,
        componentKeyTwo: 1,
        componentKeyThree: 2,
        componentKeyFour: 3,
        surveys: [],
        practiceData: [],
        practiceHasSurveys: "",
        sendUserSurvey: "",
        messageSubject: "",
        messageContent: "",
      }
    },
    computed: {
      isOnDraggableDashboard() {
        if(this.$route.meta.draggableGridStoreModule) {
          return true
        }
        return false
      },
      draggableTiles() {
          return this.$store.getters[`${this.$route.meta.draggableGridStoreModule}/getLayout`]
      },
      // The refresh button is for the demo practice only, and only on the
      // Practice Dashboard. isOnDraggableDashboard is not enough on its own -
      // the user dashboard is draggable too - so the store module is checked
      // by name.
      showRefreshDemoData() {
        if(this.$route.meta.draggableGridStoreModule !== 'practiceDashboardTileLayout') {
          return false
        }
        var practice = this.$store.getters["currentUser/getCurrentUsersPractice"]
        return !!practice && practice.toUpperCase() === 'DEMO.TRACKMYDAY.ORG'
      },
      PinnedUserAndNotLocalHost() {
        if(location.host.toLowerCase().indexOf('localhost') >= 0) {
          return false;
        } else if(this.$route.matched[0].path == '/selecteduser') {
          this.getSurveysByPractice();
          this.loadUserComponents();
          return true;
        } else {
          return false;
        }
      },
      getUserFreepass() {
        var fp = "Y";
        var zfp_sc = ".@!#$%&'*+-/=?^_`{|}~.1234567890";
        var zfp_sc2 = "qwertyuiopasdfghjklzxv0987654321";
        var ztxt2 = "";
        var ztxt = this.$store.getters["pinnedUser/getPinnedUsersLogin"];
        var zc;
        var zcc;

        for (var zct = 0; zct < ztxt.length; zct++)
        {
            zc = ztxt.substr(zct,1);
            if (zfp_sc.indexOf(zc) > -1)
            {
                zc = zfp_sc2.substr(zfp_sc.indexOf(zc), 1);
            }
            else
            {
                zcc = zc.charCodeAt(0) + 5;
                if (zcc > 90)
                {
                    zcc -= 26;
                }
                zc = String.fromCharCode(zcc) + "";
            }

            ztxt2 = zc + ztxt2;
        }

        fp += ztxt2;
        return fp;
      },
      selectedUsersLogin() {
        if(this.$store.getters['pinnedUser/isUserPinned']) {
          return this.$store.getters["pinnedUser/getPinnedUsersLogin"]
        } else {
          return "No User Pinned"
        }
      },
      // showAIChatBotIcon() {
      //       var role = this.$store.getters["currentUser/getCurrentUsersRole"]
      //       if (role == 'MANAGEMENT' || role == 'PRACTICE-MANAGEMENT' || role == 'SERVICE' || role == 'PROVIDER' || role == 'COACH') {
      //         console.log("role of user", role);
      //         return true
      //       } else {
      //           return false
      //       }
      // }
    },
    methods: {
      getUserSurvey() {
        return this.sendUserSurvey;
      },
      getMessageSubject() {
        return this.messageSubject;
      },
      getMessageContent() {
        return this.messageContent;
      },
      async getPracticeInfo() {
          var retrievedPracticeRecord = await PracticeServices.getCurrentPractice(this.$store.getters["currentUser/getCurrentUsersPractice"])
          if(retrievedPracticeRecord && retrievedPracticeRecord.result){
          this.practiceData = retrievedPracticeRecord.result
          }
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },
      saveTileHiddenState(tile) {
        tile.hidden = !tile.hidden
        this.$store.commit(`${this.$route.meta.draggableGridStoreModule}/saveTileHiddenState`, tile)
      },
      resetTilesToInitialLayout() {
        this.$store.dispatch(`${this.$route.meta.draggableGridStoreModule}/resetLayoutToInitialState`)
      },
      async refreshDemoData() {
        // Guard as well as :disabled - a double click can fire twice before
        // Vue re-renders the disabled state.
        if(this.isRefreshingDemoData) {
          return
        }
        this.isRefreshingDemoData = true

        try {
          var response = await RefreshDemoDataServices.refreshDemoData()

          // The gateway envelope is { result, status, message }. Every
          // successful path carries a message; when the API fails, the
          // gateway wraps the error and the message does not survive, so
          // "no message" is the failure signal.
          //
          // Note the API runs the refresh on a background task and answers
          // immediately, so this returns in milliseconds and the message says
          // the refresh has STARTED - not that it has finished. The dashboard
          // is deliberately NOT reloaded when the modal closes: the data is
          // still being written at that point. Press the button again to see
          // whether it is done - it answers 'busy' while running and 'already
          // up to date' once it has finished.
          var message = response && response.message ? response.message : ""

          if(message) {
            this.refreshDemoDataMessage = message
            this.refreshDemoDataSucceeded = true
          } else {
            this.refreshDemoDataMessage = "Demo data refresh failed. Please try again, or check the API logs if it keeps failing."
            this.refreshDemoDataSucceeded = false
          }
        } catch(ex) {
          this.refreshDemoDataMessage = "Demo data refresh failed. Please try again, or check the API logs if it keeps failing."
          this.refreshDemoDataSucceeded = false
        } finally {
          // Always re-enable the button and always report the outcome, so a
          // failure can never leave it stuck in the disabled state.
          this.isRefreshingDemoData = false
          this.modalControls.refreshDemoDataModal = true
        }
      },
      openUserMessageModal() {
        this.sendUserSurvey = "";
        this.messageSubject = "";
        this.messageContent = "";
        this.reloadMessagePanel();
        this.modalControls.messageModal = true;
      },
     async openUserDocumentModal(){
         this.sendUserSurvey = "";
        this.messageSubject = "";
        this.messageContent = "";
        this.modalControls.documentModal = true;
        this.$store.dispatch('patientInteractionTimer/recordAction', 'documentAssigned')
      },
      sendSurvey(survey) {
        var surveyMessage = "";
        var surveyUrl = "";
        this.sendUserSurvey = survey.name;

        if(this.practiceData.short_name != '') {
          this.messageSubject = this.practiceData.short_name + " would like you to complete this Survey";
          surveyUrl += "https://" + this.practiceData.code.toLowerCase() + "/portal/main/formdriver.ASP?formn=" + survey.name + "&fp=" + this.getUserFreepass;

          surveyMessage += "Hi " + this.$store.getters["pinnedUser/getPinnedUsersFirstName"] + ", <br><br>" + this.practiceData.short_name + " would like you to complete this Survey:<br><br>";
          surveyMessage += "<a href='" + surveyUrl + "'>" + survey.title + "</a><br><br>";
          surveyMessage += "Be well!<br>";
          surveyMessage += this.practiceData.short_name + "<br><br>";
          surveyMessage += "You are receiving this message from " + this.practiceData.short_name + ".<br><br>" 
          surveyMessage += "If you have received this message in error please contact <a href='mailto:" + this.practiceData.email + "'>" + this.practiceData.email + "</a> or call " + this.practiceData.phone + ".";

          this.messageContent = surveyMessage;
        } else {
          this.messageSubject = "Please complete this Survey";
          this.messageContent = survey.title;
        }

        this.reloadMessagePanel();
        this.modalControls.messageModal = true;
        this.$store.dispatch('patientInteractionTimer/recordAction', 'surveySent')
      },
      sendMessage(message){
        this.modalControls.messageModal = false
        var logins = this.$store.getters["pinnedUser/getPinnedUsersLogin"];
         var practice = this.$store.getters["currentUser/getCurrentUsersPractice" ];
         var currentUser= this.$store.getters["currentUser/getCurrentUsersLogin"];
         var sendEmailMessage={
           Login:logins,
           CurrentUser:currentUser,
           PracticeCode:practice,
           messageFrom:message.from,
           messageReplyTo:message.replyTo,
           messageSubject:message.subject,
           messageDeliveryType:message.deliveryType,
           messageBody:message.content,
           document:message.fileData,
           app:'true'
         }
        MessagingServices.sendMessageToListOfUsers(sendEmailMessage)
        // Notify of success
          this.$notify({
            title: 'Message Sent',
            horizontalAlign: 'left',
            verticalAlign: 'bottom',
            type: 'success',
            timeout: 3000,
            showClose: false
        })
        this.$store.dispatch('patientInteractionTimer/recordAction', 'messageSent')
      },
      openInitialReport() {
        var login = this.$store.getters["pinnedUser/getPinnedUsersLogin"];

        if(login != '') {
          var url = "../home/applets/scale_data_report_1.asp?print=0&zthis_login=" + login;
          this.$store.dispatch('patientInteractionTimer/recordAction', 'openedInitialReport')
          window.open(url);
        }
      },
      openFollowUpReport() {
        var login = this.$store.getters["pinnedUser/getPinnedUsersLogin"];

        if(login != '') {
          var url = "../home/applets/scale_data_report_2.asp?print=0&zthis_login=" + login;
          this.$store.dispatch('patientInteractionTimer/recordAction', 'openedFollowUpReport')
          window.open(url);
        }
      },
      async loadUserComponents() {
        var thisPractice = this.$store.getters["currentUser/getCurrentUsersPractice"];
        var thisUser = this.$store.getters["pinnedUser/getPinnedUsersLogin"];

        var components = await PracticeServices.LoadComponentsList(thisPractice, thisUser);
        if(components && components.result)
        {
          this.componentsList = components.result;
          
          if(this.componentsList?.indexOf(",VALHALLA_SCALE,") > -1) {
            this.hasValhallaScale = "1";
          };

          this.reloadComponents();
        }
      },
      async getSurveysByPractice() {

        var thisPractice = this.$store.getters["currentUser/getCurrentUsersPractice"];
        var surveys = await PracticeServices.getSurveysByPractice(thisPractice);
        if(surveys)
        {
            this.surveys = surveys.result;

            if(this.surveys.length > 0) {
            this.practiceHasSurveys = "1";
           }

        this.reloadSurveyData();
        }
       
      },
      reloadComponents() {
        this.componentKey += 1;
        this.componentKeyTwo += 1;
      },
      reloadMessagePanel() {
        this.componentKeyThree += 1;
      },
      reloadSurveyData() {
        this.componentKeyFour += 1;
      },
      goToMyAccount() {
        redirectToOldPracticeDashboard("../home/healthtrac/my_account.asp", null, {SPH_RETURN: ""})
      },
      callLogout() {
        logout()
      }
    },
    mounted() {
      this.getPracticeInfo();
    }
  }
</script>

<style scoped>
.modal-primary {text-align: center;}

.resetTileButton {
  margin-left: 30%;
}

/* Sits in the navbar next to the tile and settings icons, so it is kept small
   and low-contrast rather than looking like a primary page action. */
.refresh-demo-data-btn {
  margin-top: 8px;
  margin-right: 6px;
  padding: 5px 12px;
  border: 1px solid #51bcda;
  border-radius: 4px;
  background-color: #51bcda;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;
  transition: opacity .15s ease, filter .15s ease, background-color .15s ease;
}

.refresh-demo-data-btn i {
  margin-right: 5px;
}

/* Stays the same colour on hover - only a slight lift, so the button does not
   change appearance while the pointer is over it. */
.refresh-demo-data-btn:hover:not(:disabled),
.refresh-demo-data-btn:focus:not(:disabled) {
  background-color: #51bcda;
  color: #FFFFFF;
  opacity: .9;
  outline: none;
}

/* Processing state: blurred, dimmed and not clickable, with the icon swapped
   for element-ui's spinner. */
.refresh-demo-data-btn.is-refreshing,
.refresh-demo-data-btn:disabled {
  filter: blur(1px);
  opacity: .6;
  cursor: not-allowed;
  pointer-events: none;
}

.refresh-demo-data-result {
  text-align: center;
}

.refresh-demo-data-result p {
  margin: 0;
  font-size: 15px;
}

.refresh-demo-data-result-icon {
  display: block;
  margin-bottom: 12px;
  font-size: 40px;
}

.refresh-demo-data-result-icon.text-success {
  color: #7ac29a;
}

.refresh-demo-data-result-icon.text-danger {
  color: #eb5e28;
}
</style>

<style>
.send-user-message-modal .modal-dialog {min-width:830px;}
.coust-mt-2{
  margin-top: 0.9rem !important;
}
</style>